import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faCalendar,
  faUser
} from '@fortawesome/free-regular-svg-icons'
import {
  faArchive,
  faArrowLeft,
  faBars,
  faChartLine,
  faChartPie,
  faCheck,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faEdit,
  faFileContract,
  faFileExcel,
  faFileInvoice,
  faFilePdf,
  faFileWord,
  faFileAlt,
  faFilter,
  faHandHoldingUsd,
  faMapMarkerAlt,
  faPaperclip,
  faPaperPlane,
  faPlus,
  faRedoAlt,
  faSearch,
  faSortAmountDown,
  faSortAmountUp,
  faTachometerAlt,
  faTimes,
  faTimesCircle,
  faTrashAlt,
  faShoppingCart,
  faFolder,
  faClipboard,
  faCog,
  faEllipsisV,
  faSlidersH,
  faCaretDown,
  faCaretRight,
  faFile
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faCalendar,
  faUser
)

library.add(
  faArchive,
  faArrowLeft,
  faBars,
  faChartLine,
  faChartPie,
  faCheck,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faEdit,
  faFileContract,
  faFileExcel,
  faFileInvoice,
  faFilePdf,
  faFileWord,
  faFileAlt,
  faFilter,
  faHandHoldingUsd,
  faMapMarkerAlt,
  faPaperclip,
  faPaperPlane,
  faPlus,
  faRedoAlt,
  faSearch,
  faSortAmountDown,
  faSortAmountUp,
  faTachometerAlt,
  faTimes,
  faTimesCircle,
  faTrashAlt,
  faShoppingCart,
  faFolder,
  faClipboard,
  faCog,
  faEllipsisV,
  faSlidersH,
  faCaretDown,
  faCaretRight,
  faFile
)

Vue.component('fa-icon', FontAwesomeIcon)
